import React, { useState, useEffect } from "react";
import SingleChoice from "./SingleChoice";
import MultipleChoice from "./MultipleChoice";
import QuestionAndAnswer from "./QuestionAndAnswer";
import { useLocation } from "react-router-dom";
import { Button, Empty, Pagination, message, Modal, Select } from 'antd';
import { BarChartOutlined, LeftOutlined } from "@ant-design/icons";
import { useNavigate } from 'react-router-dom';
import './Quiz.scss';
import { createQuestionSubmit, createQuizSubmit, getAnswersByQuizId, getQuestionsByQuesIds, duplicateQuizByQuizId, getSubmitStatic, getSubmitDetail } from "../../requests";

function getAnswers(list) {
    const l = list.map((ele) => ele.selectOption);
    return l;
}

function getCorrCount(list) {
    let i = 0;
    const wrongIds = [];
    list.forEach(element => {
        if (element.isCorrect) {
            i++;
        } else {
            wrongIds.push(element.question_id);
        }
    });
    return { correctCount: i, wrongIds: wrongIds };
}

// function getWrongQuesId(list){
//     list.forEach(element => {
//         if(!element.isCorrect){
//             i++;
//         }
//     });
//     return i;
// }

function QuizPractice(props) {
    const location = useLocation();
    const { quizType, questionIdList, quiz_id, backPath, attemp, testsListIndex, mode } = location.state;
    const [questionList, setQuestionList] = useState([]);
    const user = JSON.parse(localStorage.getItem('user')) || JSON.parse(localStorage.getItem('tempUser'));
    const [submitted, setSubmitted] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const navigate = useNavigate();
    const [current, setCurrent] = useState(1);
    const [statistic, setStatistic] = useState({});
    const [detail, setDetail] = useState({});

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [hasFinished, setHasFinished] = useState(false);


    useEffect(() => {
        const isTempConvert = localStorage.getItem('tempConvert') || JSON.parse(localStorage.getItem('tempConvert'));
        if (isTempConvert) {
            // handlePageChange(6)
            localStorage.removeItem('tempConvert')
        }
    }, [])

    // const [total, setTotal] = useState(questionIdList.length);
    useEffect(() => {
        const func = async () => {
            const list = await getQuestionsByQuesIds(questionIdList);
            const answersList = await getAnswersByQuizId(quiz_id, attemp);
            const map = new Map();
            answersList.forEach(ele => {
                map.set(ele.question_id, ele);
            })
            if (mode !== 'redo') {
                list.forEach((element, index) => {
                    if (map.get(element.question_id)) {
                        list[index] = { ...element, selectOption: map.get(element.question_id).question_answer }
                    }
                });
            }
            setQuestionList(list);
            if (mode === 'redo') {
                return;
            }
            const res = await getSubmitDetail({
                quiz_id: quiz_id,
                mode: '1',
                attemp: attemp,
            })
            const temp = res.map(ele => ele.question_id)
            let last = 0;
            list.forEach((ele, index) => {
                if (temp.indexOf(ele.question_id) !== -1) {
                    last = index
                }
            })
            handlePageChange(last + 1)
            if (last + 1 === list.length) {
                await getSubmits();
                setHasFinished(true);
            }
        }
        try {
            func();
        } catch (err) {
            console.log(err)
        }
    }, [questionIdList, quiz_id, attemp])

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
        localStorage.setItem('tempConvert', user.user_id)
        navigate('/register')
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const getSubmits = async () => {
        const res = await Promise.all([getSubmitStatic({
            quiz_id: quiz_id,
            mode: '1',
            attemp: attemp,
        }), getSubmitDetail({
            quiz_id: quiz_id,
            mode: '1',
            attemp: attemp,
        })])
        setStatistic(res[0]);
        const r = {}
        res[1].forEach(ele => {
            r[ele.question_id] = ele.is_correct
        })
        setDetail(r)
    }


    const listChange = async (index, item) => {
        const newQL = questionList.slice(questionList);
        newQL[index] = item;
        setQuestionList(newQL);
    }

    const handleSubmit = async (item) => {
        const { submitId } = await createQuestionSubmit({
            quiz_id: quiz_id,
            mode: '1',
            attemp: attemp,
            question_id: item.question_id,
            user_id: user.user_id,
            question_answer: item.selectOption,
            time_spend: item.time_spend,
            isCorrect: item.isCorrect
        });
        // messageApi.success('Submit success');
        if (current < questionList.length) {
            // item.type !== 3 && setTimeout(() => {
            //     setCurrent(current + 1);
            // }, (3000));
        } else {
            if (user.login_method === 'temp_user') {
                showModal();
                return;
            }
            messageApi.success('Congradulation! You have done all questions!');
            await getSubmits();
            setHasFinished(true);
        }

    }

    const handlePageChange = (page) => {
        // if (user.login_method === 'temp_user' && page > 5) {
        //     showModal();
        // } else {
        setCurrent(page);
        // }
    }

    const handleTryAgin = async () => {
        const newQuiz = await duplicateQuizByQuizId({ quiz_id: quiz_id, attemp: attemp });
        const testList = JSON.parse(localStorage.getItem('testsList'));
        testList.forEach((ele, index) => {
            if (testList[index].quiz_id === newQuiz.quiz_id) {
                testList[index] = { ...ele, ...newQuiz };
            }
        });
        localStorage.setItem('testsList', JSON.stringify(testList));
        navigate(backPath, {
            state: {
                mode: mode
            }
        });
    }

    const handleNextQuiz = async () => {
        const testsList = JSON.parse(localStorage.getItem('testsList'))
        const i = testsListIndex + 1;
        navigate('/quiz', {
            state: {
                mode: mode,
                questionIdList: testsList[i].content,
                attemp: testsList[i].attemp,
                quiz_id: testsList[i].quiz_id,
                backPath: '/public-test-list',
                testsListIndex: i
            },
            replace: true
        })
        setHasFinished(false);
        handlePageChange(1)
    }

    const handleRedo = () => {
        const wrongList = [];
        for (const key in detail) {
            if (Object.hasOwnProperty.call(detail, key)) {
                const element = detail[key];
                if (!element) {
                    wrongList.push(parseInt(key))
                }
            }
        }
        const i = testsListIndex + 1;
        navigate('/quiz', {
            state: {
                mode: 'redo',
                questionIdList: wrongList,
                attemp: attemp,
                quiz_id: quiz_id,
                backPath: '/public-test-list',
                testsListIndex: i,
            },
            replace: true
        })
        setHasFinished(false);
        handlePageChange(1)
    }

    const renderTitle = () => {
        switch (questionList[current - 1].type) {
            case 1: {
                return (
                    <div className="d-flex justify-content-center">
                        <h1 className="text-xl font-semibold" style={{ marginBottom: '0' }}>Single Choice</h1>
                    </div>
                );
            }
            case 2: {
                return (
                    <div className="d-flex justify-content-center" style={{ height: '36px' }}>
                        <h1 className="text-xl font-semibold" style={{ marginBottom: '0' }}>Multiple Choice</h1>
                    </div>
                );
            }
            case 3: {
                return (
                    <div className="d-flex justify-content-center" style={{ height: '36px' }}>
                        <h1 className="text-xl font-semibold" style={{ marginBottom: '0' }}>Question and Answer</h1>
                    </div>
                );
            }
        }
    }
    const renderComp = () => {
        switch (questionList[current - 1].type) {
            case 1: {
                return (
                    <div className="container">
                        {
                            // questionList.map((ele, key)=>
                            <div className="d-flex align-items-center" style={{ height: 'calc(100% - 36px)' }}>
                                <SingleChoice key={current - 1} index={current - 1} {...questionList[current - 1]} valueChange={(newItem) => { listChange(current - 1, newItem) }} onSubmit={(newItem) => handleSubmit(newItem)} mode={mode} />
                            </div>
                            // )
                        }
                    </div>
                );
            }
            case 2: {
                return (
                    <div className="container">
                        {
                            // questionList.map((ele, key)=>
                            <div className="d-flex align-items-center" style={{ height: 'calc(100% - 36px)' }}>
                                <MultipleChoice key={current - 1} index={current - 1} {...questionList[current - 1]} valueChange={(newItem) => { listChange(current - 1, newItem) }} onSubmit={(newItem) => handleSubmit(newItem)} mode={mode} />
                            </div>
                            // )
                        }
                    </div>
                );
            }
            case 3: {
                return (
                    <div className="container">
                        {
                            // questionList.map((ele, key)=>
                            <div className="d-flex align-items-center" style={{ height: 'calc(100% - 36px)' }}>
                                <QuestionAndAnswer key={current - 1} index={current - 1} {...questionList[current - 1]} valueChange={(newItem) => { listChange(current - 1, newItem) }} onSubmit={(newItem) => handleSubmit(newItem)} mode={mode} />
                            </div>
                            // )
                        }
                    </div>
                );
            }
        }
    }
    console.log((detail))
    return (
        <div className="container p-4" style={{ marginBottom: '6vh' }}>
            <div className='flex items-center justify-between mb-4'>
                <LeftOutlined className="text-gray-600" style={{ fontSize: '22px' }} onClick={() => navigate(backPath || '/quiz-set', {
                    state: {
                        mode: mode
                    }
                })} />
                {questionList.length > 0 ? renderTitle() : <Empty />}
                <div style={{ width: '22px' }}></div>
            </div>
            {contextHolder}

            <div style={{ height: 'vh', overflow: 'auto' }}>
                {/* <div className= 'container mt-2 d-flex justify-content-between flex-column' style={{marginTop: '20px'}}> */}
                {/* <h3 style={{margin: '20px'}}>Single Choice</h3> */}
                <>
                    {questionList.length > 0 ? renderComp() : <Empty />}
                </>
                {/* </div> */}
                {(hasFinished && current === questionList.length) ? <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', margin: '20px 0' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <BarChartOutlined />
                            &nbsp;&nbsp;&nbsp;<span style={{ color: 'red' }}>{statistic.incorrect} x</span>
                            &nbsp;&nbsp;&nbsp;<span style={{ color: 'green' }}>{statistic.correct} √</span>
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {
                                questionList.map((ele, index) => {
                                    return <div
                                        style={{ color: detail[ele.question_id] == 1 ? 'green' : (detail[ele.question_id] == 0) ? 'red' : 'black', width: 'fit-content', minWidth: '10%' }}
                                    >
                                        {index + 1}{detail[ele.question_id] == 1 ? '√' : (detail[ele.question_id] == 0 ? 'X' : '')}&nbsp;&nbsp;&nbsp;
                                    </div>
                                })
                            }
                            {Object.values(detail).filter(v => v === 0).length !== 0 ? <a onClick={handleRedo} className="cursor-pointer">Redo Mistakes</a> : <span style={{ color: 'green' }}>Congradulations!</span>}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <span>You've done it <span style={{ fontSize: '20px', fontWeight: 600 }}>{attemp}</span> times!</span>
                        </div>
                    </div>
                    <div style={{ height: '20px' }} />
                    <Button type="primary" onClick={handleTryAgin}>Try Again!</Button>
                    <br />
                    <Button type="primary" onClick={handleNextQuiz}>Go to next quiz!</Button>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '20px 0' }}>
                        <span>Power by&nbsp;</span><a href="https://weieducation.ca/" target="_blank">AskWei</a>
                    </div>
                </div> : null}

                <div className="d-flex justify-content-evenly align-items-center" style={{ position: 'fixed', bottom: '0', left: 0, right: 0, width: '100%', padding: '2vh 0' }}>
                    {/* <Pagination simple pageSize={1} current={current} total={questionIdList.length} onChange={(p) => handlePageChange(p)} /> */}
                    <Button type="primary" onClick={() => handlePageChange(current - 1)} disabled={current == 1}>Prev</Button>
                    <span>
                        <Select
                            suffixIcon={null}
                            options={questionList.map((ele, index) => { return { value: index + 1, label: index + 1 } })}
                            value={current}
                            className="my-page-selector"
                            style={{ width: '60px', border: 'none' }}
                            onChange={value => handlePageChange(value)} />&nbsp;&nbsp;/&nbsp;&nbsp;{questionList.length}
                    </span>
                    <Button type="primary" onClick={() => handlePageChange(current + 1)} disabled={current == questionList.length}>Next</Button>
                </div>
            </div>

            <Modal title="Notice" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} okText={'Register'}>
                <p>Unlock 262 Chinese and 173 English exercises by registering today for free!</p>
            </Modal>
            {/* <div className='container mt-2 d-flex justify-content-between flex-column bottom-button'>
                <Button type="primary" onClick={handleSubmit}>Submit</Button>
            </div>         */}
        </div>
    );
}

export default QuizPractice;